import { api as axios } from '@/plugins/axios';

export const postFeedControl = async (token, payload) => {
  const config = {
    method: 'post',
    url: `/v1/feed-controls`,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
    data: payload,
  };
  const { data } = await axios(config);
  return data;
};

export const getSiloOccupationHistory = async (token, id, params = undefined) => {
  const config = {
    method: 'get',
    url: `/v2/silos/${id}/occupation-history`,
    params,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const putFeedControl = async (token, id, payload) => {
  const config = {
    method: 'patch',
    url: `/v1/feed-controls/${id}`,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
    data: payload,
  };
  const { data } = await axios(config);
  return data;
};

export const deleteFeedControl = async (token, id) => {
  const config = {
    method: 'delete',
    url: `/v1/feed-controls/${id}`,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const getSilosShed = async (token, id) => {
  const config = {
    method: 'get',
    url: `/v1/silos-shed/${id}`,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const getFeedControls = async (token, id, params = {}) => {
  const config = {
    method: 'get',
    url: `/v1/feed-controls`,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
    params: {
      batch: id,
      ...params,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const getRationTypes = async (token, companyId) => {
  const config = {
    method: 'get',
    url: '/v1/ration-types',
    headers: {
      'Authorization': 'Bearer ' + token,
    },
    params: {
      company: companyId,
      offset: 0,
      limit: 999,
    },
  };
  const { data } = await axios(config);
  return data;
};
export const getAlertById = async (token, id) => {
  const config = {
    method: 'get',
    url: '/v2/alerts/minimal_consumption/',
    headers: {
      'Authorization': 'Bearer ' + token,
    },
    params: {
      shed: id,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const postAlert = async (token, payload) => {
  //  payload example: {
  // "shed": "<shed_uuid>",
  // "name": "Alerta de Consumo",
  // "active_alert": true,
  // "min_consumption_value": 100,
  // "start_time": "08:00:00",
  // "end_time": "18:00:00",
  // "interval": 4
  // }
  const config = {
    method: 'post',
    url: `/v2/alerts/minimal_consumption/`,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
    data: payload,
  };
  const { data } = await axios(config);
  return data;
};

export const updateAlert = async (token, id, payload) => {
  const config = {
    method: 'patch',
    url: `/v2/alerts/minimal_consumption/${id}/`,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
    data: payload,
  };
  const { data } = await axios(config);
  return data;
};

export const deleteAlert = async (token, id) => {
  const config = {
    method: 'delete',
    url: `/v2/alerts/minimal_consumption/${id}/`,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const getBatchHydrometry = async (token, batchId) => {
  const { data } = await axios({
    method : 'get',
    url : `/v2/batches/${batchId}/hydrometry/`,
    headers : {
      Authorization : 'Bearer ' + token,
    },
  })
  return data;
  };

export const getBatchHydrometryHistory = async (token, batchId, params) => {
  const { data } = await axios({
    method: 'get',
    url: `/v2/batches/${batchId}/hydrometry-history/`,
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};